/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import {
  TextField,
  Select,
  Typography,
  FormControlLabel,
  FormControl,
  MenuItem,
  InputLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from '@material-ui/core';
import { isEmpty, get, map, includes, orderBy } from 'lodash';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment-timezone';
import { CheckCircle } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import frLocale from 'date-fns/locale/fr';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

import { CHOICES, INJURY_POST } from 'containers/PreOpeningPage/constants';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import {
  Config,
  SagisConfig,
  CodesConfig,
} from 'containers/AppContainer/typings';
import {
  CLAIM,
  VEHICULE,
  VICTIM,
  EMPTY_VEHICULE,
  CLAIM_STATUS,
} from 'containers/data-structure';
import { claimInformationValidator } from 'containers/PreOpeningPage/ClaimInformation';
import {
  displayErrorText,
  formsAreValidated,
} from 'containers/services/validateForm';
import { arrayTranslate } from 'containers/services/translate';
import {
  getCities,
  resolveLossDateValidationMessage,
} from 'containers/RecapManagerPage/utils';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import recapManagerMessages from 'containers/RecapManagerPage/messages';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { VictimType } from 'typings/globalTypes';

export interface ValidationDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: any;
  authorityTypes: Config[];
  claimToPreopen: any;
  inputLabelProps?: boolean;
  vehicleBrands: SagisConfig[];
  compagnies: SagisConfig[];
  insuranceCompanies: CodesConfig[];
  setClaimRecap?: Function;
  cities: SagisConfig[];
  countries: SagisConfig[];
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  jurisdictions?: Config[];
  disableLossDate?: boolean;
  policyInfo?: any;
  requestSearchClaims?: Function;
  foundClaims?: any;
}
const Container = styled.div`
  .fields {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 500px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
    color: #4f4f4f;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .input {
    width: 327px;
    margin-bottom: 20px;
    margin-left: 24px;
    margin-right: 24px;
  }
  .label-input {
    font-size: 13px;
  }
  .subContainer {
    display: flex;
    flex-direction: column;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #2b2727;
    margin-right: 17px;
    font-weight: Bold;
    font-family: Roboto;
  }
  .checkdiv {
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    margin-right: 24px;
  }
`;

const ClaimInformationModificationDrawer: React.FC<ValidationDrawerProps> = (
  props,
): JSX.Element => {
  const [claimToPreopen, updateClaim] = useState({ ...props.claimToPreopen });

  const [claimInformationValidation, setClaimInformationValidation] = useState(
    {},
  );

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;
    const expectedClaimToPreopen: any = { ...claimToPreopen };
    expectedClaimToPreopen.vehicule = expectedClaimToPreopen.vehicule || {};
    switch (field) {
      case CLAIM.PV_NUMBER:
        expectedClaimToPreopen.claim[CLAIM.PV_NUMBER] = value;
        break;
      case CLAIM.LOSS_LOCATION:
        expectedClaimToPreopen.claim[CLAIM.LOSS_LOCATION] = get(
          valueField,
          'ItemKey',
        );
        break;
      case CLAIM.AUTHORITY_TYPE:
        expectedClaimToPreopen.claim[CLAIM.AUTHORITY_TYPE] = value;
        break;
      case CLAIM.AUTHORITY_NAME:
        expectedClaimToPreopen.claim[CLAIM.AUTHORITY_NAME] = value;
        break;
      case CLAIM.HAS_MATERIAL_DAMAGES:
        expectedClaimToPreopen.claim[CLAIM.HAS_MATERIAL_DAMAGES] = !!(
          value === 'true'
        );
        expectedClaimToPreopen.vehicule = expectedClaimToPreopen.claim[
          CLAIM.HAS_MATERIAL_DAMAGES
        ]
          ? isEmpty(props.claimToPreopen.vehicule)
            ? EMPTY_VEHICULE
            : { ...props.claimToPreopen.vehicule }
          : {};
        break;
      case VEHICULE.BRAND:
        expectedClaimToPreopen.vehicule[VEHICULE.BRAND] = get(
          valueField,
          'ItemKey',
        );
        break;
      case VEHICULE.OPPOSING_PARTY:
        expectedClaimToPreopen.vehicule[VEHICULE.OPPOSING_PARTY] = value;
        break;
      case VEHICULE.REGISTRATION_NUMBER:
        expectedClaimToPreopen.vehicule[VEHICULE.REGISTRATION_NUMBER] = value;
        break;
      case CLAIM.LOSS_HOUR:
        claim[CLAIM.LOSS_HOUR] = valueField;
        break;
      case CLAIM.COUNTRY_ID:
        claim[CLAIM.COUNTRY_ID] = value;
        claim[CLAIM.LOSS_LOCATION] = null;
        break;
      case CLAIM.FIRM_REFERENCE:
        expectedClaimToPreopen.claim[CLAIM.FIRM_REFERENCE] = value;
        break;
      case CLAIM.JURISDICTION_ID:
        expectedClaimToPreopen.claim[CLAIM.JURISDICTION_ID] = value;
        break;
      default:
        return expectedClaimToPreopen;
    }
    updateClaim(expectedClaimToPreopen);
  };

  const [isClaimExist, setIsClaimExist] = useState(false);
  const [updatedLossDate, setUpdatedLossDate] = useState<any>(null);

  useEffect(() => {
    setIsClaimExist(
      !isEmpty(get(props.foundClaims, 'corporeal')) ||
        !isEmpty(get(props.foundClaims, 'sagis.claims')),
    );
    if (
      updatedLossDate &&
      !resolveLossDateValidationMessage(props.foundClaims, props)?.disable
    ) {
      claim[CLAIM.LOSS_DATE] = moment(updatedLossDate as Date).format();
    }
  }, [props.foundClaims, updatedLossDate]);

  const handleDateChange = (field: string) => (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const expectedClaimToPreopen = { ...claimToPreopen };

    switch (field) {
      case CLAIM.LOSS_DATE:
        if (!isNaN(theDate?.getTime())) {
          setUpdatedLossDate(theDate);
          props.requestSearchClaims &&
            props.requestSearchClaims({
              lossDate: theDate,
              policyNumber: get(props.policyInfo, 'sagis.policy.policyNumber'),
              isEdit: true,
            });
        }
        break;
      default:
        return expectedClaimToPreopen;
    }
    updateClaim(expectedClaimToPreopen);
  };

  const handleLossHourChange = (event: any) => {
    const { value } = event.target || '';

    const time = value.replace(':', '');
    const [hours, minutes] = [time.slice(0, 2), time.slice(2, 4)];
    const [hoursForTest, minutesForTest] = [hours, minutes].map((t: any) =>
      t && t.length < 2 ? t * 10 : t,
    );
    if (hoursForTest < 24 && (!minutes || minutesForTest < 60)) {
      handleChange(CLAIM.LOSS_HOUR)(
        event as any,
        [hours, minutes].filter(t => !!t).join(':'),
      );
    }
  };

  const filtredCompanies = (
    companies: SagisConfig[],
    filter: CodesConfig[],
  ) => {
    const filterCodes = map(filter, 'code');
    const filtredCompanies = companies.filter(({ ItemKey }) =>
      filterCodes.includes(ItemKey),
    );
    return filtredCompanies;
  };

  const handleValidateDrawer = () => () => {
    if (props.setClaimRecap) {
      const expectedClaimToPreopen = { ...claimToPreopen };

      expectedClaimToPreopen.claim[CLAIM.HAS_MATERIAL_DAMAGES] = !isEmpty(
        expectedClaimToPreopen.vehicule,
      )
        ? CHOICES.YES
        : CHOICES.NO;

      const validator =
        claimInformationValidator(expectedClaimToPreopen, true) || {};
      setClaimInformationValidation(validator);
      if (formsAreValidated(validator)) {
        props.setClaimRecap({ ...expectedClaimToPreopen });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.PV_NUMBER]: expectedClaimToPreopen.claim[CLAIM.PV_NUMBER],
              [CLAIM.LOSS_LOCATION]:
                expectedClaimToPreopen.claim[CLAIM.LOSS_LOCATION],
              [CLAIM.AUTHORITY_TYPE]:
                expectedClaimToPreopen.claim[CLAIM.AUTHORITY_TYPE],
              [CLAIM.AUTHORITY_NAME]:
                expectedClaimToPreopen.claim[CLAIM.AUTHORITY_NAME],
              [CLAIM.HAS_MATERIAL_DAMAGES]:
                expectedClaimToPreopen.claim[CLAIM.HAS_MATERIAL_DAMAGES],
              [CLAIM.LOSS_HOUR]: expectedClaimToPreopen.claim[CLAIM.LOSS_HOUR],
              [CLAIM.COUNTRY_ID]:
                expectedClaimToPreopen.claim[CLAIM.COUNTRY_ID],
              [CLAIM.FIRM_REFERENCE]:
                expectedClaimToPreopen.claim[CLAIM.FIRM_REFERENCE],
              [CLAIM.LOSS_DATE]: expectedClaimToPreopen.claim[CLAIM.LOSS_DATE],
            },
          });
        props.handleToggleDrawer();
      }
    }
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    claimInformationValidation,
    translateArrayErrorMessages(claimInformationValidation, true),
  );

  const { claim, vehicule } = claimToPreopen;

  const numberOfXVictims = (X: string[]) => {
    return (
      claimToPreopen.victims &&
      claimToPreopen.victims.filter((victim: VictimType) =>
        includes(X, victim[VICTIM.INJURY_POST_KEY]),
      ).length
    );
  };

  const brand = () => {
    if (props.vehicleBrands && props.vehicleBrands.length)
      return props.vehicleBrands.find(
        brand => brand.ItemKey === get(vehicule, [VEHICULE.BRAND]),
      );
    return {} as SagisConfig;
  };

  const lossLocation = () => {
    if (props.cities && props.cities.length)
      return props.cities.find(
        city => city.ItemKey === get(claim, [CLAIM.LOSS_LOCATION]),
      );
    return {} as SagisConfig;
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) => option?.ItemDescription,
  });

  const inputLabel = React.useRef<HTMLLabelElement>(null);

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={() => props.handleToggleDrawer(true)}
      title={translate(
        { ...messages.claimInformationModificationDrawerTitle },
        props,
      )}
      handleValidateDrawer={handleValidateDrawer()}
      confirmButtonTitle={translate(
        recapManagerMessages.drawerSaveFormButtonTitle,
        props,
      )}
      isSaveButtonDisabled={
        resolveLossDateValidationMessage(props.foundClaims, props)?.disable
      }
    >
      <Container>
        <div className="fields">
          <TextField
            id="pvNumber"
            onChange={handleChange(CLAIM.PV_NUMBER)}
            name={CLAIM.PV_NUMBER}
            value={get(claim, [CLAIM.PV_NUMBER])}
            label={translate({ ...messages.pvNumero }, props)}
            className="input"
            InputLabelProps={{ shrink: props.inputLabelProps }}
            error={!!get(claimInformationValidation, [CLAIM.PV_NUMBER])}
            helperText={message[CLAIM.PV_NUMBER]}
          ></TextField>
          <FormControl
            className="input"
            error={!!get(claimInformationValidation, [CLAIM.COUNTRY_ID])}
          >
            <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
              {translate({ ...messages.country }, props)}
            </InputLabel>
            <Select
              onChange={handleChange(CLAIM.COUNTRY_ID)}
              name={CLAIM.COUNTRY_ID}
              value={get(claim, [CLAIM.COUNTRY_ID], '')}
              labelWidth={60}
            >
              {!isEmpty(props.countries) &&
                props.countries.map(country => (
                  <MenuItem value={country.ItemKey} key={country.ItemKey}>
                    {country.ItemDescription}
                  </MenuItem>
                ))}
            </Select>
            {!!get(claimInformationValidation, [CLAIM.COUNTRY_ID]) && (
              <FormHelperText className="errorSelect">
                {message[CLAIM.COUNTRY_ID]}
              </FormHelperText>
            )}
          </FormControl>
          <Autocomplete
            id="standard-basic-2"
            className="input"
            options={getCities(props.cities, get(claim, [CLAIM.COUNTRY_ID]))}
            getOptionLabel={city => city.ItemDescription}
            autoSelect={true}
            onChange={handleChange(CLAIM.LOSS_LOCATION)}
            value={lossLocation()}
            filterOptions={filterOptions}
            renderInput={params => (
              <TextField
                {...params}
                name={CLAIM.LOSS_LOCATION}
                label={translate({ ...messages.claimPlace }, props)}
                error={!!get(claimInformationValidation, [CLAIM.LOSS_LOCATION])}
                helperText={message[CLAIM.LOSS_LOCATION]}
              />
            )}
          />
          {featureService.hasFeature(
            FEATURES.ASSIGNMENT_JURISDICTION_LAWYER,
          ) && (
            <FormControl
              className="input"
              error={!!get(claimInformationValidation, [CLAIM.JURISDICTION_ID])}
            >
              <InputLabel id="jurisdiction-label-id">
                {translate(messages.jurisdiction, props)}
              </InputLabel>
              <Select
                onChange={handleChange(CLAIM.JURISDICTION_ID)}
                name={CLAIM.JURISDICTION_ID}
                value={get(claim, [CLAIM.JURISDICTION_ID], '')}
              >
                {orderBy(
                  get(props, 'jurisdictions', []),
                  [el => el?.title?.toLowerCase()],
                  ['asc'],
                ).map((el: Config) => (
                  <MenuItem key={el.id} value={el.id}>
                    {el.title}
                  </MenuItem>
                ))}
              </Select>
              {!!get(claimInformationValidation, [CLAIM.JURISDICTION_ID]) && (
                <FormHelperText className="errorSelect">
                  {message[CLAIM.JURISDICTION_ID]}
                </FormHelperText>
              )}
            </FormControl>
          )}
          {!props.disableLossDate && (
            <>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  id="lossDate"
                  onChange={handleDateChange(CLAIM.LOSS_DATE)}
                  name={CLAIM.LOSS_DATE}
                  value={dateStringToLocalDate(
                    get(claim, [CLAIM.LOSS_DATE], ''),
                  )}
                  label={translate({ ...messages.claimDate }, props)}
                  className="input"
                  InputLabelProps={{
                    shrink:
                      props.inputLabelProps ||
                      !!get(claim, [CLAIM.LOSS_DATE], ''),
                    classes: { root: 'label-input' },
                  }}
                  error={
                    !!get(claimInformationValidation, [CLAIM.LOSS_DATE]) ||
                    dateStringToLocalDate(get(claim, [CLAIM.LOSS_DATE], '')) ===
                      'Invalid date'
                  }
                  helperText={
                    message[CLAIM.LOSS_DATE] ||
                    (dateStringToLocalDate(
                      get(claim, [CLAIM.LOSS_DATE], ''),
                    ) === 'Invalid date' &&
                      translate(messages.invalidDate, props))
                  }
                  disabled={!isEmpty(get(props.policyInfo, 'sagis.claims'))}
                />
              </MuiPickersUtilsProvider>
              <span
                style={{
                  marginLeft: '25px',
                  marginBottom: '20px',
                  color: 'red',
                }}
              >
                {
                  resolveLossDateValidationMessage(props.foundClaims, props)
                    ?.message
                }
                {!isEmpty(get(props.policyInfo, 'sagis.claims')) &&
                  get(claimToPreopen, 'claim.status') ===
                    CLAIM_STATUS.PENDING &&
                  translate(
                    { ...messages.lossDateValidationMessageSagisMixte },
                    props,
                  )}
              </span>
            </>
          )}
          <TextField
            id="date-picker-claim-loss-hour"
            onChange={handleLossHourChange}
            name={CLAIM.LOSS_HOUR}
            value={get(claim, [CLAIM.LOSS_HOUR], null)}
            label={translate({ ...messages.claimHour }, props)}
            className="input"
            placeholder="HH:MM"
            InputLabelProps={{ shrink: props.inputLabelProps }}
            error={!!get(claimInformationValidation, [CLAIM.LOSS_HOUR])}
            helperText={message[CLAIM.LOSS_HOUR]}
          />
          <TextField
            id="totalInjuredVictims"
            type="number"
            name={CLAIM.TOTAL_INJURED_VICTIMS}
            value={numberOfXVictims(INJURY_POST.INJURED)}
            label={translate({ ...messages.injuredVictims }, props)}
            className="input"
            InputLabelProps={{ shrink: props.inputLabelProps }}
            disabled
          />
          <TextField
            id="totalDeceasedVictims"
            type="number"
            name={CLAIM.TOTAL_DECEASED_VICTIMS}
            value={numberOfXVictims(INJURY_POST.DECEASED)}
            label={translate({ ...messages.deceasedVictims }, props)}
            className="input"
            InputLabelProps={{ shrink: props.inputLabelProps }}
            disabled
          />
          <FormControl
            className="input"
            error={!!get(claimInformationValidation, [CLAIM.AUTHORITY_TYPE])}
          >
            <InputLabel ref={inputLabel} id="authorityType">
              {translate({ ...messages.authorityType }, props)}
            </InputLabel>
            <Select
              onChange={handleChange(CLAIM.AUTHORITY_TYPE)}
              name={CLAIM.AUTHORITY_TYPE}
              value={get(claim, [CLAIM.AUTHORITY_TYPE], '')}
            >
              {!isEmpty(props.authorityTypes) &&
                props.authorityTypes.map(type => (
                  <MenuItem value={type.id} key={type.id}>
                    {type.title}
                  </MenuItem>
                ))}
            </Select>
            {!!get(claimInformationValidation, [CLAIM.AUTHORITY_TYPE]) && (
              <FormHelperText className="errorSelect">
                {message[CLAIM.AUTHORITY_TYPE]}
              </FormHelperText>
            )}
          </FormControl>
          <TextField
            id="authorityName"
            label={translate({ ...messages.authorityName }, props)}
            onChange={handleChange(CLAIM.AUTHORITY_NAME)}
            name={CLAIM.AUTHORITY_NAME}
            value={get(claim, [CLAIM.AUTHORITY_NAME])}
            className="input"
            error={!!get(claimInformationValidation, [CLAIM.AUTHORITY_NAME])}
            helperText={message[CLAIM.AUTHORITY_NAME]}
          />
          <TextField
            id="date-picker-claim-firm-reference"
            onChange={handleChange(CLAIM.FIRM_REFERENCE)}
            name={CLAIM.FIRM_REFERENCE}
            value={get(claim, [CLAIM.FIRM_REFERENCE], null)}
            label={translate({ ...messages.firmReference }, props)}
            className="input"
            InputLabelProps={{ shrink: props.inputLabelProps }}
            error={!!get(claimInformationValidation, [CLAIM.FIRM_REFERENCE])}
            helperText={message[CLAIM.FIRM_REFERENCE]}
            disabled={true}
          />
          {!featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
            <div className="checkdiv">
              <Typography className="text">
                {translate({ ...messages.materialDamages }, props)}
              </Typography>
              <RadioGroup
                row
                onChange={handleChange(CLAIM.HAS_MATERIAL_DAMAGES)}
                value={get(
                  claim,
                  [CLAIM.HAS_MATERIAL_DAMAGES],
                  !isEmpty(vehicule),
                )}
              >
                <FormControlLabel
                  control={
                    <Radio
                      color="primary"
                      value={CHOICES.YES}
                      checkedIcon={<CheckCircle />}
                    />
                  }
                  label={translate({ ...messages.yes }, props)}
                />
                <FormControlLabel
                  control={
                    <Radio
                      color="primary"
                      value={CHOICES.NO}
                      checkedIcon={<CheckCircle />}
                    />
                  }
                  label={translate({ ...messages.no }, props)}
                />
              </RadioGroup>
              {!!get(claimInformationValidation, [
                CLAIM.HAS_MATERIAL_DAMAGES,
              ]) && (
                <FormHelperText className="error">
                  {message[CLAIM.HAS_MATERIAL_DAMAGES]}
                </FormHelperText>
              )}
            </div>
          )}
          {get(claim, [CLAIM.HAS_MATERIAL_DAMAGES], !isEmpty(vehicule)) ===
            CHOICES.YES &&
            !featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
              <div className="subContainer">
                <Autocomplete
                  id="vehicleBrands"
                  className="input"
                  options={props.vehicleBrands}
                  getOptionLabel={brand => brand.ItemDescription}
                  autoSelect={true}
                  onChange={handleChange(VEHICULE.BRAND)}
                  value={brand()}
                  filterOptions={filterOptions}
                  renderInput={params => (
                    <TextField
                      {...params}
                      name={VEHICULE.BRAND}
                      label={translate(
                        { ...messages.claimInformationVehicleBrand },
                        props,
                      )}
                      error={
                        !!get(claimInformationValidation, [VEHICULE.BRAND])
                      }
                      helperText={message[VEHICULE.BRAND]}
                    />
                  )}
                />
                <TextField
                  id="registration"
                  label={translate({ ...messages.registration }, props)}
                  className="input"
                  onChange={handleChange(VEHICULE.REGISTRATION_NUMBER)}
                  name={VEHICULE.REGISTRATION_NUMBER}
                  value={get(vehicule, [VEHICULE.REGISTRATION_NUMBER])}
                  error={
                    !!get(claimInformationValidation, [
                      CLAIM.REGISTRATION_NUMBER,
                    ])
                  }
                  helperText={message[CLAIM.REGISTRATION_NUMBER]}
                />
                <FormControl className="input">
                  <InputLabel>
                    {translate({ ...messages.opposingCompanies }, props)}
                  </InputLabel>
                  <Select
                    onChange={handleChange(VEHICULE.OPPOSING_PARTY)}
                    name={VEHICULE.OPPOSING_PARTY}
                    value={get(vehicule, [VEHICULE.OPPOSING_PARTY], '')}
                  >
                    {!isEmpty(props.compagnies) &&
                      filtredCompanies(
                        props.compagnies,
                        props.insuranceCompanies,
                      ).map(company => (
                        <MenuItem value={company.ItemKey} key={company.ItemKey}>
                          {company.ItemDescription}
                        </MenuItem>
                      ))}
                  </Select>
                  {!!get(claimInformationValidation, [
                    VEHICULE.OPPOSING_PARTY,
                  ]) && (
                    <FormHelperText className="errorSelect">
                      {message[VEHICULE.OPPOSING_PARTY]}
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
            )}
        </div>
      </Container>
    </SahamDrawer>
  );
};

export default injectIntl(ClaimInformationModificationDrawer);
